module.exports = __webpack_public_path__ + "static/media/fly0027.6481880b.webp";